import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faBars,faHome,faUserCircle,faSearch,faArrowLeft,faTrash,
faTimes,faUser,faCogs,faPowerOff,faBox,faSort,faEllipsisV,faEdit,
faPen,faPlus,faShoppingCart,faFolder,faList,faSackDollar,faCalendar,
faThumbTack,faUsers,faSignOutAlt,faEnvelope,faShop,faCheck,faArrowUp,
faExchangeAlt,faTools,faBell,faCodeBranch,faChartBar} 
from '@fortawesome/free-solid-svg-icons';

import { faWhatsapp, faFacebook, faTwitter } from '@fortawesome/free-brands-svg-icons'; 

// Add icons to the library
library.add(faBars,faHome,faUserCircle,faSearch,faArrowLeft,faTimes,
faUser,faCogs,faPowerOff,faBox,faSort,faEllipsisV,faEdit,faTrash,
faPen,faPlus,faShoppingCart,faFolder,faBox,faList,faSackDollar,faCalendar,
faThumbTack,faUsers,faSignOutAlt,faEnvelope,faWhatsapp,faFacebook,faTwitter,faShop,faCheck,
faArrowUp,faExchangeAlt,faTools,faBell,faCodeBranch,faChartBar);

// Register the FontAwesomeIcon component globally
export { FontAwesomeIcon }; 
